export interface TokenDefinition {
  regex: RegExp;
  typeName: string;
}

export interface Token {
  type: string;
  value: any;
}

export class Lexer {
  private tokenDefinitions: TokenDefinition[];
  constructor(tokenDefinitions: TokenDefinition[]) {
    this.tokenDefinitions = tokenDefinitions;
  }

  public lex(input: string): Token[] {
    const tokens: Token[] = [];
    let foundToken = false;

    let match: RegExpMatchArray | null;
    let i: number;
    const numTokenTypes = this.tokenDefinitions.length;
    input = input.replace("[>]", "%")
    do {
      for (i = 0; i < numTokenTypes; i++) {
        match = this.tokenDefinitions[i].regex.exec(input);
        if (match) {
          tokens.push({
            type: this.tokenDefinitions[i].typeName,
            value: match[1]
          });
          input = input.substring(match[0].length);
          foundToken = true;
          break;
        }
      }
    } while (input.length > 0 && foundToken);

    return tokens;
  }
}
